import { useEffect, useState } from 'react';
import { isChromiumBrowser } from '@app/lib/browser/isChromiumBrowser';

export function useIsChromiumBrowser(): boolean {
    const [isChromium, setIsChromium] = useState(false);

    useEffect(() => {
        setIsChromium(isChromiumBrowser());
    }, []);

    return isChromium;
}
